import { useMemo } from "react";
import type { UseQueryOptions } from "react-query";

import type { GetConnectionRequestsResponse } from "@/react/api/connectionRequests/connectionRequestsApi";

import { useConnectionRequestsInfiniteQuery } from "./connectionRequests/useConnectionRequestsInfiniteQuery";

export interface UsePendingConnectionsArgs {
  options?: Partial<UseQueryOptions<GetConnectionRequestsResponse>>;
  perPage?: number;
}

export const usePendingConnections = (args: UsePendingConnectionsArgs = {}) => {
  const { perPage, options } = args;

  const result = useConnectionRequestsInfiniteQuery({
    perPage,
    options,
  });

  const audience = useMemo(
    () =>
      result.requests.map(connection => ({
        ...connection.initiator,
        connection_to_current_community_member: connection,
        type: "CommunityMember" as const,
        roles: {
          admin: Boolean(connection.initiator.admin),
          moderator: false,
        },
        email: "",
      })),
    [result.requests],
  );

  return {
    ...result,
    audience,
    totalQueryAudience: result.totalCount,
    totalAudience: result.totalCount,
  };
};
